import React from 'react';
import './index.scss';
import en from '../../locales/en-US.json';
import zh from '../../locales/zh-Hans.json';
import urlparser from 'urlparser';
import { IWeChatProps } from '../Wechat';

interface IProps {
  trailId:string,
  logo: string,
  inviterId:string,
  qrcode:string,
  error:string
}
interface IState {
  errMsg: string;
  showErr: boolean;
  email: string;
  lang: string;
  showDialog: boolean;
  message: any;
  jwt: string;
  time: string;
  custom: any;
  title: string;
  disabled: boolean;
  isWeChat: string;
  buttonUrl: string;
  logo: string;
  info: string;
  trailId:string;
  inviterId:string;
  qrcode:string;
  error:string;
}

interface IParams {
  jwt: string;
  isWeChat: string;
  weChatButtonUrl: string;
  logo: string;
  info: string;
}

export interface ITrialRes {
  time: number;
  error?: string;
  body?: {
    expireAt: number;
  };
}

export class WeChatError extends React.Component<IProps, IState> {
  public readonly state: Readonly<IState> = {
    errMsg: '',
    showErr: false,
    email: '',
    lang: 'zh-Hans',
    showDialog: false,
    message: {
      'zh-Hans': zh,
      'en-US': en
    },
    jwt: '',
    time: '',
    custom: '',
    title: '',
    disabled: false,
    isWeChat: '',
    buttonUrl: '',
    logo: '',
    info: '',
    trailId:'',
    inviterId:'',
    qrcode:'',
    error:''
  };

  UNSAFE_componentWillMount() {
    let url = urlparser.parse(window.location.href);
    let path = url.path.base;
    if (path === 'trial/activity-kw') {
      let custom = require('../../assets/kw.png');
      this.setState({
        custom
      });
    }
  }

  componentDidMount() {
    this.setState(
      {
        trailId:this.props.trailId,
        logo: this.props.logo,
        inviterId:this.props.inviterId,
        qrcode:this.props.qrcode,
        error:this.props.error
      });
  }

  render() {
    const { error } = this.state;
    return (
      <div id="error-page">
        <section id="header">
          <div className="custom">
            {this.state.logo ? <img src={this.state.logo} alt=""/> : null}
          </div>
          <h1 className="title">Oops!</h1>
          <p className="description">{error ? error : 'error'}</p>
        </section>
        <section id="form">
          {this.state.qrcode?<div className="weChatShare">
            <img src={this.state.qrcode?this.state.qrcode:require('../../assets/wechatQrcode.jpg')} alt=""/>
            <p>长按二维码关注iSlide</p>
            <p>获取更多资源</p>
          </div>:null}
        </section>
      </div>
    );
  }
}
